import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, makeObservable } from 'mobx';

const wholesalerContractForm = {
  fields: {
    sellerName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'Wholesaler name is required.',
    },
    acquisitionPrice: {
      value: 0,
      error: null,
      rule: 'required',
      message: 'Wholesale acquisition price is required.',
    },
    sellerCredit: {
      value: '',
      error: null,
      rule: '',
    },
    // Special Conditions UI is parked pending business review. The field is
    // commented out so the form never reads or writes it: with no key in
    // form.fields, getFormValues() omits it entirely and GenericDocReview's
    // mergeUiData leaves the stored value untouched on save.
    // specialConditions: {
    //   value: [],
    //   error: null,
    //   rule: '',
    // },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class WholesalerContractFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...wholesalerContractForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    this.loadForm(data);
  }
}
